// Datos del titular para los documentos legales.
// IMPORTANTE: completar los campos marcados como "(por confirmar)" con la
// información fiscal real antes de considerar estos documentos definitivos,
// y validarlos con un abogado (Ley Federal de Protección al Consumidor / PROFECO
// y legislación de datos personales vigente).
export const LEGAL = {
    marca: "Monoticket",
    sitio: "https://www.monoticket.mx",
    razonSocial: "(razón social por confirmar)",
    rfc: "(RFC por confirmar)",
    domicilio: "(domicilio por confirmar)",
    ciudadEstado: "(ciudad y estado por confirmar)",
    correoContacto: "contacto@monoticket.mx",
    correoPrivacidad: "privacidad@monoticket.mx",
    actualizacion: "28 de junio de 2026",
};
